/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { ConvertSystemInfo } from '../../../../../feature/src/lib/models/convert-system-info';
import { ConvertOptionReturnCodes } from '../../../../../feature/src/lib/models/place-coupling-return-codes';
import { ConvertOptionState } from '../../../../../feature/src/lib/models/convert-option-state';
import { Observable } from 'rxjs';

export interface IConvertOptionsFacade {
    changeHeight(height: number): void;
    saveData(convertSystemInfo: ConvertSystemInfo): Observable<any>;
    updateRetainValue(value: boolean): Observable<any>;
    updateIsIgnoreValue(value: boolean): Observable<any>;
    getInitialData(): Observable<ConvertSystemInfo>;
    closeWindow(): void;
    validateSelection(convertOptionState: ConvertOptionState): Observable<ConvertOptionReturnCodes>;
    registerControllers(): void;
    updateLocalStorage(key: string, value: any): void;
    getLocalStorage(key: string): any;
    updateCouplingAlignment(value: boolean): Observable<any>;
}

export const CONVERT_OPTIONS_FACADE_TOKEN = new InjectionToken<IConvertOptionsFacade>('CONVERT_OPTIONS_FACADE_TOKEN');